<template>
  <aside class="d-none d-lg-block side orientation col-4 z-index-2" :aria-label="$t('mod.sidebar.title')">
    <div class="step-info d-flex" v-if="$store.state.showNavigation">
      <div class="step-number align-self-start flex-shrink-0">{{ $store.getters.activeStepIndex + 1 }}</div>
      <div class="title align-self-center mt-0">{{ $store.getters.activeStep.title }}</div>
    </div>
    <div class="location-info">
      <div class="address">
        <div class="name">
          <i :class="`${$store.state.faClass} fa-lg fa-fw fa-map-marker-alt`"
             role="img" :aria-label="$t('mod.sidebar.address') + ':'"
          ></i>{{ $store.state.contact.name }}
        </div>
        <div class="street">{{ $store.state.contact.street }}</div>
        <div class="place">{{ $store.state.contact.zip }} {{ $store.state.contact.place }}</div>
      </div>
      <div class="contact">
        <div class="heading">
          <i :class="`${$store.state.faClass} fa-lg fa-fw fa-comment-alt`"
             aria-hidden="true"></i>{{ $t('mod.sidebar.contact') }}
        </div>
        <div class="telephone d-flex align-items-center">
          <i :class="`${$store.state.faClass} fa-phone fa-fw me-1`" role="img" :aria-label="$t('mod.sidebar.phone') + ':'"></i>
          {{ $store.state.contact.telephone }}
        </div>
        <div class="mobile d-flex align-items-center" v-if="$store.state.contact.mobile">
          <i :class="`${$store.state.faClass} fa-mobile-alt fa-fw me-1`" role="img"
             aria-label="Mobiltelefonnummer: "></i>
          {{ $store.state.contact.mobile }}
        </div>
        <div class="mail d-flex align-items-center" v-if="$store.state.contact.mail">
          <i :class="`${$store.state.faClass} fa-envelope fa-fw me-1`" role="img" :aria-label="$t('mod.sidebar.email') + ':'"></i>
          {{ $store.state.contact.mail }}
        </div>
      </div>
    </div>
  </aside>
</template>
<script>

export default {
  components: {}
};
</script>